let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2zLjK")).then(() => parcelRequire('3UB4H'));